<template>
  <div v-if="isLoading" class="fixed top-0 left-0 right-0 h-1 bg-blue-500/20 z-50 overflow-hidden">
    <div class="h-full w-1/3 bg-blue-500 animate-[loading_1.2s_infinite]"></div>
  </div>
</template>

<script setup lang="ts">
import { useLoadingStore } from '@repo/ui/stores/loading'
import { storeToRefs } from 'pinia'

const loadingStore = useLoadingStore()
const { isLoading } = storeToRefs(loadingStore)
</script>

<style>
@keyframes loading {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(300%); }
}
</style>

